module.exports = __webpack_public_path__ + "img/introducepinxdetail_bodyimage03.e3856591.jpg";